<template>
  <div>
    <div>
      <el-form ref="auditForm" :model="auditForm">
        <div class="tips">
          任务申请审核人意见
          <el-row
            v-if="taskInfo.status == 1 && auditSize == 1"
            style="float: right"
          >
            <el-button size="medium" @click="submitAuditForm(1)" type="primary"
              >通过</el-button
            >
            <el-button size="medium" @click="submitAuditForm(0)" type="warning"
              >驳回</el-button
            >
            <el-button size="medium" @click="submitAuditForm(4)" type="danger"
              >终止</el-button
            >
          </el-row>
        </div>
        <div class="clearfix">
          <div>
            <el-tabs type="card">
              <el-tab-pane
                v-for="(item, index) in auditList"
                :label="item.reviewtime"
                :key="index"
              >
                <el-button>{{ item.xm }}/{{ item.statusname }}</el-button>
                <div style="margin: 10px 0"></div>
                <el-form-item prop="bz">
                  <el-input
                    type="textarea"
                    placeholder="请输入意见"
                    v-model="auditForm.bz"
                    maxlength="100"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-input
                  style="display: none"
                  ref="applyId"
                  v-model="item.id"
                ></el-input>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <div class="tips">申请人信息</div>
      <div class="creat-info">
        <div>申请人信息：{{ taskInfo.createby }}</div>
        <div>申请人职位：{{ taskInfo.creategw }}</div>
        <div>申请人部门：{{ taskInfo.createbm }}</div>
      </div>
    </div>
    <div>
      <div class="tips">任务模板附件</div>
      <el-table
        :max-height="height"
        :data="templateData"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="uploader"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="文件名称"
          align="left"
          prop="filename"
          min-width="300px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="openPreview(scope.row)" type="primary">{{
                scope.row.filename
              }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="操作"
          align="left"
          prop="name"
          min-width="80px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="downloadFile(scope.row)" type="primary"
                >下载</el-link
              >
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
    <div>
      <div class="tips">任务信息</div>
      <div>
        <el-form
          ref="form"
          :model="taskInfo"
          label-width="80px"
          class="clearfix"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务编号：" label-width="150px">
                <el-input disabled v-model="taskInfo.rwbh"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务标题：" label-width="150px">
                <el-input disabled v-model="taskInfo.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务所属条线：" label-width="150px">
                <el-input disabled v-model="taskInfo.txname"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务所属部门：" label-width="150px">
                <el-input disabled v-model="taskInfo.bmmc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务类型：" label-width="150px">
                <el-input disabled v-model="taskInfo.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任务子类：" label-width="150px">
                <el-input disabled v-model="taskInfo.sun"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item
                label="标准积分"
                prop="jf"
                key="5"
                label-width="150px"
              >
                <el-input-number
                  v-model="taskInfo.jf"
                  :min="0"
                  class="reward-input"
                  :max="99999"
                  disabled
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="任务说明：" label-width="150px">
                <div id="wangEditor"></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="预期成果说明：" label-width="150px">
                <div id="wangEditor2"></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务结束时间：" label-width="150px">
                <el-input disabled v-model="taskInfo.jsrq"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计划总工时(人/日):" label-width="150px">
                <el-input disabled v-model="taskInfo.gs"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label=" 认领对象：" label-width="150px">
                <el-input disabled v-model="taskInfo.rldx"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：" label-width="150px">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  show-word-limit
                  placeholder="请输入说明"
                  v-model="taskInfo.bz"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import {
  getTaskAuditDetials,
  saveTaskRl,
  saveTaskApplyAudit,
} from "@/api/task.js";

export default {
  name: "taskApplyAudit",
  computed: { ...mapGetters(["user", "task"]) },
  components: {},
  props: ["mxParams"],
  data() {
    return {
      auditForm: {
        taskId: null,
        status: null,
        isAdmin: 1,
        bz: null,
        applyId: null,
      },
      taskInfo: {},
      xzrStatus: 1,
      wbStatus: 1,
      activeIndex: "1",
      templateData: [],
      auditList: [],
      auditSize: 0,
      saveParams: {
        taskId: null,
        ygbhs: null,
        otheryg: null,
        isAdmin: null,
      },
      parentDialog: false,
    };
  },

  created() {
    this.saveParams.taskId = this.mxParams.id;
    getTaskAuditDetials({ taskId: this.mxParams.id, type: 1 }).then((res) => {
      if (res.code == 0) {
        this.templateData = res.data.files;
        this.auditList = res.data.audit;
        if (res.data.audit.length > 0) {
          this.auditSize = 1;
        }
        this.taskInfo = res.data.task;
        this.editor.txt.html(this.taskInfo.rwsm);
        this.editor2.txt.html(this.taskInfo.yqjg);
        this.xzrStatus = 1;
        this.wbStatus = 1;
      }
    });
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);
    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      // editor.config.uploadImgServer = window.g.apiUrl + '/common/uploadForumFile'
      // editor.config.uploadImgHeaders = {
      //   "x-token": localStorage.getItem("token"), // 设置请求头
      // };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      editor.disable();
      return editor;
    },
    submitAuditForm(type) {
      this.auditForm.status = type;
      this.auditForm.taskId = this.taskInfo.taskid;
      if (this.$refs.applyId) {
        this.auditForm.applyId = this.$refs.applyId[0].value;
      }
      saveTaskApplyAudit(this.auditForm).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "task/fetchTaskListAction",
            this.task.taskList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChangeXzr(e) {
      this.xzrStatus = e;
    },
    handleChangeIsAdmin(e) {
      this.isAdminStatus = e;
    },
    handleSelect(key) {
      this.activeIndex = key;
    },
    handleChangeWb(e) {
      this.wbStatus = e;
    },
    openPreview(row) {
      const url = row.previewurl;
      window.open(url);
    },
    downloadFile(row) {
      const filePath = row.url;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    saveRwrl() {
      saveTaskRl(this.saveParams).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.creat-info {
  display: flex;
  justify-content: space-around;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
</style>